import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function BottomNav() {
  const location = useLocation();

  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "null");

  return (
    <nav
      className="navbar fixed-bottom navbar-dark bg-dark d-flex justify-content-around"
      style={{ height: "60px" }}
    >
      <Link to="/" className={`nav-link ${location.pathname === "/" ? "active" : ""}`}>
        🏠
      </Link>
      <Link to="/friends" className={`nav-link ${location.pathname === "/friends" ? "active" : ""}`}>
        👥
      </Link>
      <Link to="/upload" className={`nav-link ${location.pathname === "/upload" ? "active" : ""}`}>
        ➕
      </Link>
      <Link to="/messages" className={`nav-link ${location.pathname === "/messages" ? "active" : ""}`}>
        💬
      </Link>
      <Link
        to={`/user/${encodeURIComponent(currentUser?.pseudo || "profil")}`}
        className={`nav-link ${location.pathname.startsWith("/user") ? "active" : ""}`}
      >
        👤
      </Link>
    </nav>
  );
}

